import React from 'react'
import { useRecordContext } from 'react-admin'
import AcUnitIcon from '@mui/icons-material/AcUnit';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import { Box, Typography, Tooltip } from '@mui/material';


const getTemperatureColor = (temp) => {
    if (temp <= 20) return '#2196f3';  // blue - cold
    if (temp <= 40) return '#4caf50';  // green - cool
    if (temp <= 60) return '#ff9800';  // orange - warm
    if (temp <= 80) return '#f44336';  // red - hot
    return '#d32f2f';                   // dark red - very hot
};

const TemperatureField = () => {
    const record = useRecordContext();

    if (!record || record.lead_temperature == null) {
        return null;
    }

    const temp = record.lead_temperature;
    const color = getTemperatureColor(temp);
    const Icon = temp <= 30 ? AcUnitIcon : WhatshotIcon;

    return (
        <Tooltip title={`${temp}°`}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Icon sx={{ fontSize: 18, color }} />
                <Typography variant="body2" sx={{ color, fontWeight: 600 }}>
                    {temp}
                </Typography>
            </Box>
        </Tooltip>
    );
};

export default TemperatureField;
